import WidgetBase from '../widget.base';
import {querify, getUrlParamByName, each} from '../../lib/util';
import Pager from '../../components/pager/pager';

const RESULTS_PER_PAGE = 25;

export default class SearchResults extends WidgetBase {
    static selector = '[data-js-search-results]';
    constructor(el) {
        super(el);

        const pagerEl = this.el.querySelector('[data-pager]');

        const {totalResults, currentPage, searchTerm} = this.el.dataset;

        this.$el = $(el);
        this.searchTerm = searchTerm;
        this.filterValues = "";
        this.$mobileFilterAccordion = $('[data-js-mobile-accordion-toggle]', el);
        this.$mobileAccordionContent = $('[data-js-content]', el);
        this.$resetFilterButton = $('[data-reset]', el);
        this.$mobileFilterAccordion.on('click', function() {
            const $this = $(this);
            if ($this.hasClass('open')) {
                $this.removeClass('open').next().slideUp();
            }
            else {
                $this.addClass('open').next().slideDown();
            }
        });
        this.$resetFilterButton.on('click', this.resetFilters.bind(this));
        this.$filterCheckboxes = $('[data-js-filter-checkbox]', el);
        this.getFiltersFromUrl();
        this.$filterCheckboxes.on('change', () => {
            this.getFilters();
        });

        // prevent downloads of inline video search results
        this.$videos = this.$el.find('[data-js-prevent-download]');
        this.preventVideoDownloads();

        if(pagerEl) {
            this.pager = new Pager(pagerEl, {
                perPage: RESULTS_PER_PAGE,
                initialPage: parseInt(currentPage)
            });

            this.pager.update(parseInt(currentPage), totalResults)

            this.pager.listen('page:change', (e) => {
                const newUrlParams = {
                    page: e.detail,
                    term: searchTerm,
                    filters: this.filterValues
                };
                const newUrl = `${window.location.pathname}?${querify(newUrlParams)}`;
                window.location = newUrl;
            });
        }

        setTimeout(() => {
            this.loaded();
        });
    }

    // prevent downloads of inline video search results
    preventVideoDownloads() {
        each(this.$videos, (x) => {
            $(x).bind('contextmenu', () => false);
        });
    }

    // get the selected checkbox values. Append to querystring so BE can filter accordingly
    getFilters() {
        const valueArr = [];
        const $checkedFilters = $('[data-js-filter-checkbox]:checked', this.el);
        $checkedFilters.each(function() {
            valueArr.push(this.value);
        });
        this.filterValues = valueArr.join(',');

        const newUrlParams = {
            page: 1,
            term: this.searchTerm,
            filters: this.filterValues
        };
        const newUrl = `${window.location.pathname}?${querify(newUrlParams)}`;
        window.location = newUrl;
    }

    // populate filter checkboxes with filter querystring
    getFiltersFromUrl() {
        const filters = getUrlParamByName('filters');
        if (filters == null || '') {
            return;
        }
        this.filterValues = filters;
        const filterArr = filters.split(',');
        each(filterArr, (filterVal) => {
            const $checkbox = $(`[data-js-filter-checkbox][value="${filterVal}"]`, this.el);
            $checkbox.attr('checked', true);
        });
    }

    resetFilters() {
        this.$filterCheckboxes.attr('checked', false);
        this.getFilters();
    }
}
